import { ProductWithVariants } from '../interfaces/products';

export const getDefaultProduct = (productWithVariants: ProductWithVariants) =>
  productWithVariants.variants.find((variant) => variant.isDefault) ?? productWithVariants.variants[0];

export const getDefaultProducts = (productsWithVariants: ProductWithVariants[]) =>
  productsWithVariants.map(getDefaultProduct);
